import { MediaObject as DrywallMediaObject } from 'drywall';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { MediaObjectMixin } from '../../mixins/components/MediaObjectMixin';
import CustomPropTypes from '../../util/custom-prop-types';

/**
 * @since 7.6.0
 */
var MediaObject = /*#__PURE__*/styled(function (props) {
  return /*#__PURE__*/React.createElement(DrywallMediaObject, props);
}).withConfig({
  displayName: "MediaObject",
  componentId: "c11n-8-107-0__sc-1c6i1ap-0"
})(["", ""], MediaObjectMixin);
MediaObject.displayName = 'MediaObject';
MediaObject.propTypes = {
  /**
   * How to align the media content with respect to the children content.
   */
  align: PropTypes.oneOf(['start', 'top', 'center', 'bottom', 'end']),
  /**
   * The body content.
   */
  children: PropTypes.node.isRequired,
  /**
   * The direction in which the media and content will be placed.
   */
  direction: PropTypes.oneOf(['column', 'row']),
  /**
   * The spacing value between media and children content.
   */
  gutter: CustomPropTypes.spacing,
  /**
   * The media content.
   */
  media: PropTypes.node.isRequired,
  /**
   * You can use `renderLayout` to modify the default composition of the component.
   * Pass your own node using the `<MediaObject.Body>` and `<MediaObject.Media>` wrappers,
   * or pass a render function that receives enhanced props as the only argument.
   */
  renderLayout: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * By default, the media will come before the body.
   * Set this to reverse the order of media and body.
   */
  reverse: PropTypes.bool
};
MediaObject.defaultProps = {
  direction: 'row',
  gutter: 'sm'
};
MediaObject.Body = DrywallMediaObject.Body;
MediaObject.Media = DrywallMediaObject.Media;

/** @component */
export { MediaObject };